"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataGroupType = void 0;
var DataGroupType;
(function (DataGroupType) {
    DataGroupType[DataGroupType["NONE"] = 0] = "NONE";
    DataGroupType[DataGroupType["BLOCK"] = 1] = "BLOCK";
    DataGroupType[DataGroupType["BUILDING"] = 2] = "BUILDING";
    DataGroupType[DataGroupType["PHASE"] = 3] = "PHASE";
    DataGroupType[DataGroupType["ESTATE"] = 4] = "ESTATE";
    DataGroupType[DataGroupType["DISTRICT"] = 5] = "DISTRICT";
    DataGroupType[DataGroupType["VILLAGEHOUSE"] = 6] = "VILLAGEHOUSE";
    DataGroupType[DataGroupType["AREA"] = 7] = "AREA";
})(DataGroupType = exports.DataGroupType || (exports.DataGroupType = {}));
